module.exports = __webpack_public_path__ + "img/male-user.4eb122f6.png";